<template>
  <div id="app">
    {{val}}
  </div>
</template>
<script>
export default {
  data:function(){
    return{
      val:0
    }
  },
  methods:{
    updateNum(){
      ++this.val;
    }
  },
  mounted(){
    setInterval(this.updateNum,1000);
  }
}
</script>
<style>
#app{
  text-align: center;
  font: 700 30px/1.5 arial;
}
</style>
